(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    const form = section?.querySelector('form.ishvarya-buy-form');
    const mainButton = form?.querySelector('xo-cart-add button');
    const variants = JSON.parse(root.querySelector('[data-mobile-variants]').textContent);
    const action = root.querySelector('[data-mobile-purchase]');
    const edit = root.querySelector('[data-mobile-edit]');
    const selection = root.querySelector('[data-mobile-selection]');
    if (!form || !mainButton) return;
    root.dataset.ready = 'true';
    let formSeen = false;
    let queued = false;
    const mobile = matchMedia('(max-width: 749px)');
    const info = section.querySelector('.ishvarya-format-area') || form;
    function update() {
      queued = false;
      const rect = mainButton.getBoundingClientRect();
      const passed = rect.height > 0 && rect.bottom <= 0;
      if (passed) formSeen = true;
      const locked = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
      root.hidden = !mobile.matches || !passed || locked;
      const variant = variants.find(v => String(v.id) === String(form.querySelector('[name="id"]')?.value));
      const quantity = form.querySelector('[name="quantity"]')?.value || '1';
      if (variant) selection.textContent = [variant.title === 'Default Title' ? '' : variant.title, variant.price, root.dataset.qty + ' ' + quantity].filter(Boolean).join(' · ');
      const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || !variant?.available;
      action.textContent = !variants.some(v => v.available) ? root.dataset.soldOut : !formSeen ? root.dataset.choose : disabled ? (variant?.available ? mainButton.textContent.trim() : root.dataset.soldOut) : root.dataset.add;
      action.disabled = !variants.some(v => v.available) || (formSeen && disabled);
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    function choose() {
      info.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      const option = info.querySelector('button:not([disabled]),select,input:not([type="hidden"])');
      option?.focus({preventScroll:true});
    }
    action.addEventListener('click', () => {
      if (!formSeen) { choose(); return; }
      if (mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
      mainButton.click(); schedule();
    });
    edit.addEventListener('click', choose);
    form.addEventListener('input',schedule);
    form.addEventListener('change',schedule);
    document.addEventListener('ishvarya:format-changed',schedule);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    new MutationObserver(schedule).observe(form,{subtree:true,attributes:true,childList:true,characterData:true});
    new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class','style']});
    new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['class','style']});
    update();
  }
  function scan() { document.querySelectorAll('[data-ish-mobile-purchase]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  document.addEventListener('shopify:section:load',scan);
})();
